export default "__VITE_ASSET__D96uP1LV__"